export default __webpack_public_path__ + "static/viinitie-banner-corporate-desktop-narrow.5a55a3e593de3a00d0e9f4acdf67cf98.jpg";